/*
  © 2025 TeamDrop
  https://www.teamdrop.com.br
*/

class Cart extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('[name="updates[]"]').forEach(input => {
      input.addEventListener('change', () => {
        this.change(input.dataset.lineItemKey, Number(input.value))
      })
    })

    this.querySelectorAll('.btn-line-item-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        this.change(btn.dataset.lineItemKey, 0)
      })
    })

    this.querySelectorAll('.select-line-item-change').forEach(select =>
      select.addEventListener('change', () => {
        const lineItemKey = select.dataset.lineItemKey
        const newVariantId = Number(select.value)
        const quantity = Number(select.dataset.quantity)
        this.changeVariant(lineItemKey, newVariantId, quantity)
      })
    )

    this.querySelectorAll('.upgrade-to-sub select').forEach(select =>
      select.addEventListener('change', () => {
        const lineItemKey = select.dataset.lineItemKey
        const newVariantId = Number(select.dataset.variantId)
        const quantity = Number(select.dataset.quantity)
        const sellingPlanId = Number(select.value)
        this.upgradeToSubscription(lineItemKey, newVariantId, quantity, sellingPlanId)
      })
    )
    
    this.showOffcanvasIfUrl()
    this.adjustCollapses()
  }
 
  async add (formData) {
    let response

    if (formData instanceof FormData) {
      formData.append('sections', ['cart-count-badge', 'offcanvas-cart'])
      formData.append('sections_url', window.location.pathname)

      response = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
        method: 'POST',
        body: formData
      })
    } else {
      formData.sections = ['cart-count-badge', 'offcanvas-cart']
      formData.sections_url = window.location.pathname

      response = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
    }

    console.log(response)
    const data = await response.json()
    console.log(data)

    if (response.ok) {
      window.dispatchEvent(new CustomEvent('td.cart.added', { detail: data }))
      this.reloadCartElements(data.sections)
    } else {
      this.showError(data.description)
    }

    document.querySelectorAll('.offcanvas').forEach(offcanvas => {
      if (offcanvas.id === 'offcanvas-cart') {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show()
      } else {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).hide()
      }
    })
  }

  async change (id, quantity) {
    this.classList.add('loading')

    const response = await fetch(`${window.Shopify.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id,
        quantity,
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
    console.log(response)
    const data = await response.json()
    console.log(data)

    if (response.ok) {
      window.dispatchEvent(new CustomEvent('td.cart.changed', { detail: data }))
      this.reloadCartElements(data.sections)
    } else {
      this.showError(data.description)
    }

    this.classList.remove('loading')
  }

  async changeVariant (lineItemKey, newVariantId, quantity) {
    this.classList.add('loading')

    const changeResponse = await fetch(`${window.Shopify.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0,
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
    console.log(changeResponse)
    const changeData = await changeResponse.json()
    console.log(changeData)

    if (changeResponse.ok) {
      window.dispatchEvent(new CustomEvent('td.cart.added', { detail: changeData }))
    } else {
      this.showError(changeData.description)
    }

    const addResponse = await fetch(`${window.Shopify.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: newVariantId, quantity }],
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
    console.log(addResponse)
    const addData = await addResponse.json()
    console.log(addData)

    if (addResponse.ok) {
      window.dispatchEvent(new CustomEvent('td.cart.changed', { detail: addData }))
      this.reloadCartElements(addData.sections)
    } else {
      this.showError(addData.description)
    }

    this.classList.remove('loading')
  }

  async upgradeToSubscription (lineItemKey, newVariantId, quantity, sellingPlanId) {
    await this.change(lineItemKey, 0)
    await this.add({
      items: [{
        id: newVariantId,
        quantity: quantity,
        selling_plan: sellingPlanId
      }]
    })
  }

  reloadCartElements (sections) {
    for (const [key, value] of Object.entries(sections)) {
      const newDoc = new DOMParser().parseFromString(value, 'text/html')

      switch (key) {
        case 'cart-count-badge':
          document.querySelectorAll('.cart-count-badge').forEach(elem => {
            const newDoc = new DOMParser().parseFromString(value, 'text/html')
            elem.replaceWith(newDoc.querySelector('.cart-count-badge'))
          })
          break
        case 'offcanvas-cart':
          const cartContainer = document.querySelector('.cart-container')
          const newCartContainer = newDoc.querySelector('cart-container')
          if (cartContainer && newCartContainer) {
            cartContainer.replaceWith(newCartContainer)
          }
          break
      }
    }

    window.dispatchEvent(new CustomEvent('td.cart.reloaded'))
  }

  showError (message) {
    const alert = this.querySelector('.alert')

    if (alert) {
      alert.querySelector('[data-alert-msg]').innerHTML = message
      alert.removeAttribute('hidden')
    }
  }

  showOffcanvasIfUrl () {
    if (new URLSearchParams(window.location.search).has('cart')) {
      const offcanvas = document.querySelector('#offcanvas-cart')

      if (offcanvas) {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show()
      }
    }
  }

  adjustCollapses () {
    this.querySelectorAll('.collapse-wrapper [data-bs-toggle="collapse"]').forEach(elem => {
      elem.addEventListener('click', () => {
        setTimeout(() => {
          const offcanvasBody = this.querySelector('.offcanvas-body')
          offcanvasBody.scroll({ top: offcanvasBody.scrollHeight, behavior: 'smooth' })
        }, 250)
      })
    })
  }
}
customElements.define('cart-container', Cart)

class CartGoal extends HTMLElement {
  constructor () {
    super()

    this.progressBar = this.querySelector('.progress-bar')
    this.animateProgressBar()
    this.initTooltips()
    this.initConfetti()
  }

  animateProgressBar () {
    setTimeout(() => {
      this.progressBar.style.width = this.progressBar.dataset.width
    }, 250)
  }

  initTooltips () {
    this.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) =>
      window.bootstrap.Tooltip.getOrCreateInstance(el))
  }

  async initConfetti () {
    if (this.dataset.showConfetti === 'false') return

    const goalCompleted = Number(this.dataset.goalCompleted)
    const prevGoalCompleted = Number(localStorage.getItem('td-cart-goal-completed') || 0)

    if (prevGoalCompleted !== goalCompleted) {
      localStorage.setItem('td-cart-goal-completed', goalCompleted)
    }

    if (goalCompleted <= prevGoalCompleted) return

    const myCanvas = document.createElement('canvas')
    myCanvas.setAttribute('id', 'cart-goal-confetti-canvas')
    document.querySelector('#offcanvas-cart .offcanvas-body').insertAdjacentElement('afterbegin', myCanvas)

    const myConfetti = window.confetti.create(myCanvas)

    myConfetti({
      particleCount: 400,
      spread: 90
    })

    setTimeout(() => {
      myCanvas.remove()
    }, 4000)
  }
}
customElements.define('cart-goal', CartGoal)

class LineItemQtySwitcher extends HTMLElement {
  constructor () {
    super()

    this.qtyInput = this.querySelector('input')
    this.minusBtn = this.querySelector('.btn-minus')
    this.plusBtn = this.querySelector('.btn-plus')

    this.minusBtn.addEventListener('click', () => this.onMinusBtnClick())
    this.plusBtn.addEventListener('click', () => this.onPlusBtnClick())
  }

  onMinusBtnClick () {
    this.qtyInput.value = Number(this.qtyInput.value) - 1
    this.qtyInput.dispatchEvent(new CustomEvent('change'))
  }

  onPlusBtnClick () {
    this.qtyInput.value = Number(this.qtyInput.value) + 1
    this.qtyInput.dispatchEvent(new CustomEvent('change'))
  }
}
customElements.define('line-item-qty-switcher', LineItemQtySwitcher)

class CartNote extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('textarea')
    this.btn = this.querySelector('button')
    this.btn.addEventListener('click', this.onSubmit.bind(this))
  }

  async onSubmit () {
    this.btn.classList.add('loading')

    await fetch(`${window.Shopify.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: this.input.value })
    })

    this.btn.innerHTML = `✓ <span class="visually-hidden">${this.btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
      this.btn.innerHTML = this.btn.dataset.textBtnSave
    }, 3000)

    this.btn.classList.remove('loading')
  }
}
customElements.define('cart-note', CartNote)

class CartDiscount extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('input')
    this.btn = this.querySelector('button')
    this.btn.addEventListener('click', this.onSubmit.bind(this))
  }

  async onSubmit () {
    this.btn.style.width = this.btn.clientWidth + 2 + 'px'
    this.btn.classList.add('loading')

    await fetch(`${window.Shopify.routes.root_url}discount/${this.input.value}`)
    window.location.href = '/checkout'

    setTimeout(() => {
      this.btn.classList.remove('loading')
    }, 2000)
  }
}
customElements.define('cart-discount', CartDiscount)

class CartShippingCalculator extends HTMLElement {
  constructor () {
    super()

    this.updateReferences()
    
    if (this.btn) {
      this.btn.addEventListener('click', this.onSubmit.bind(this))
    }

    // Busca estado automaticamente ao digitar CEP
    if (this.zip) {
      this.zip.addEventListener('input', this.onZipInput.bind(this))
    }

    // Re-inicializa quando o carrinho é recarregado
    window.addEventListener('td.cart.reloaded', () => {
      setTimeout(() => {
        this.updateReferences()
        if (this.btn && !this.btn.hasAttribute('data-listener-added')) {
          this.btn.addEventListener('click', this.onSubmit.bind(this))
          this.btn.setAttribute('data-listener-added', 'true')
        }
        if (this.zip && !this.zip.hasAttribute('data-listener-added')) {
          this.zip.addEventListener('input', this.onZipInput.bind(this))
          this.zip.setAttribute('data-listener-added', 'true')
        }
      }, 100)
    })
  }

  updateReferences () {
    this.zip = this.querySelector('#shipping-calculator-zip')
    this.alert = this.querySelector('#shipping-calculator-alert')
    
    if (!this.btn) {
      this.btn = this.querySelector('button')
    }
  }

  async onZipInput (event) {
    const zip = event.target.value.replace(/\D/g, '')
    
    // Limpa o estado em cache quando o CEP muda
    if (zip !== this.lastZip) {
      this.cachedState = null
      this.lastZip = zip
    }
    
    if (zip.length === 8) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${zip}/json/`)
        const data = await response.json()
        
        // Armazena o estado para usar no cálculo de frete
        if (!data.erro && data.uf) {
          this.cachedState = data.uf
        }
      } catch (error) {
        console.log('Erro ao buscar CEP:', error)
      }
    }
  }

  async onSubmit () {
    // Atualiza referências antes de usar (podem ter mudado após recarregamento)
    this.updateReferences()

    if (!this.zip || !this.btn) {
      console.log('Erro: campos não encontrados')
      if (this.alert) {
        this.alert.innerHTML = `
          <p class="mb-0">
            Erro: campos não encontrados. Por favor, recarregue a página.
          </p>
        `
        this.alert.classList.remove('alert-success', 'alert-warning')
        this.alert.classList.add('alert-danger')
        this.alert.removeAttribute('hidden')
      }
      return
    }

    // Valida o CEP
    const zipValue = this.zip.value.replace(/\D/g, '')
    if (zipValue.length !== 8) {
      if (this.alert) {
        this.alert.innerHTML = `
          <p class="mb-0">
            Por favor, digite um CEP válido (8 dígitos).
          </p>
        `
        this.alert.classList.remove('alert-success', 'alert-warning')
        this.alert.classList.add('alert-danger')
        this.alert.removeAttribute('hidden')
      }
      return
    }

    // Busca o estado se ainda não foi buscado
    if (!this.cachedState) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${zipValue}/json/`)
        const data = await response.json()
        
        if (data.erro || !data.uf) {
          if (this.alert) {
            this.alert.innerHTML = `
              <p class="mb-0">
                CEP não encontrado. Verifique e tente novamente.
              </p>
            `
            this.alert.classList.remove('alert-success', 'alert-warning')
            this.alert.classList.add('alert-danger')
            this.alert.removeAttribute('hidden')
          }
          return
        }
        
        this.cachedState = data.uf
      } catch (error) {
        console.log('Erro ao buscar CEP:', error)
        if (this.alert) {
          this.alert.innerHTML = `
            <p class="mb-0">
              Erro ao buscar informações do CEP. Tente novamente.
            </p>
          `
          this.alert.classList.remove('alert-success', 'alert-warning')
          this.alert.classList.add('alert-danger')
          this.alert.removeAttribute('hidden')
        }
        return
      }
    }

    this.btn.classList.add('loading')

    // País sempre é BR
    const countryValue = 'BR'
    const provinceValue = this.cachedState

    const maxRetries = 2
    let retryCount = 0
    let data = null

    while (retryCount <= maxRetries) {
      try {
        const firstRes = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zipValue}&shipping_address[country]=${countryValue}&shipping_address[province]=${provinceValue}`, {
          method: 'POST'
        })

        if (firstRes.ok) {
          const secondRes = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zipValue}&shipping_address[country]=${countryValue}&shipping_address[province]=${provinceValue}`)
          data = await secondRes.json()

          // Verifica se tem shipping_rates e sai do loop
          if (data && data.shipping_rates) {
            break
          }
        }
      } catch (error) {
        console.log('Erro na tentativa:', retryCount, error)
      }

      retryCount++
      
      if (retryCount <= maxRetries) {
        // Aguarda antes de tentar novamente
        await new Promise(resolve => setTimeout(resolve, 1000))
      }
    }

    // Se após todas as tentativas não conseguiu, mostra erro
    if (!data || !data.shipping_rates) {
      this.alert.innerHTML = `
        <p class="mb-0">
          Erro ao calcular frete. Tente novamente.
        </p>
      `
      this.alert.classList.remove('alert-success', 'alert-warning')
      this.alert.classList.add('alert-danger')
      this.alert.removeAttribute('hidden')
      this.btn.classList.remove('loading')
      return
    }

    let list = ''

    if (data.shipping_rates.length) {
      data.shipping_rates.forEach(elem => {
        const formattedPrice = window.Shopify.formatMoney ? window.Shopify.formatMoney(elem.price, window.Shopify.moneyFormat) : elem.price
        list += `
          <li>
            <strong>${elem.presentment_name}</strong>: ${formattedPrice}
          </li>
        `
      })

      this.alert.innerHTML = `
        <ul class="ps-5 mb-0">
          ${list}
        </ul>
      `
      this.alert.classList.remove('alert-danger', 'alert-warning')
      this.alert.classList.add('alert-success')
      this.alert.removeAttribute('hidden')
    } else {
      this.alert.innerHTML = `
        <p class="mb-0">
          ${this.dataset.textNoResultsFound}
        </p>
      `
      this.alert.classList.remove('alert-danger', 'alert-success')
      this.alert.classList.add('alert-warning')
      this.alert.removeAttribute('hidden')
    }

    this.btn.classList.remove('loading')
  }
}
customElements.define('cart-shipping-calculator', CartShippingCalculator)